import { Alert, Button, Container, Paper, Stack, Typography } from "@mui/material";
import { ErrorDetailContainer } from "../api/config";

export default function UserAccessError(props: {
    error: ErrorDetailContainer;
    isLoading: boolean;
    onRetry: () => void;
    onLogout: () => void;
}) {
    const isDisabled = props.error.hasError("UserDisabled");
    const isFull = props.error.hasError("UserNotActive");
    const message = isDisabled
        ? "دسترسی شما توسط صاحب حساب غیرفعال شده است. برای فعال شدن مجدد، با صاحب حساب تماس بگیرید."
        : isFull
        ? "ظرفیت کاربران فعال حساب تکمیل شده است. صاحب حساب باید یکی از کاربران را غیرفعال کند یا دسترسی شما را فعال کند."
        : props.error.getFirstError();

    return (
        <Container maxWidth="sm" sx={{ py: 8 }}>
            <Paper sx={{ p: 3 }}>
                <Stack spacing={3} alignItems="center">
                    <img src="/images/logo_default.svg" width={80} height={80} alt="پرشین سازه" />
                    <Typography variant="h6">
                        {isDisabled || isFull ? "دسترسی به پنل امکان‌پذیر نیست" : "ورود به پنل انجام نشد"}
                    </Typography>
                    <Alert severity={isDisabled || isFull ? "warning" : "error"} role="alert">{message}</Alert>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" disabled={props.isLoading} onClick={props.onRetry}>بررسی مجدد</Button>
                        <Button variant="outlined" disabled={props.isLoading} onClick={props.onLogout}>خروج از حساب</Button>
                    </Stack>
                </Stack>
            </Paper>
        </Container>
    );
}
